import { useEffect } from 'react'
import { toast as showToast } from 'react-hot-toast'
import type { Toast } from '#app/utils/toast.server.ts'

export function useToast(toast?: Toast | null) {
	useEffect(() => {
		if (toast) {
			setTimeout(() => {
				const message = toast.description
				if (toast.type === 'success') {
					showToast.success(message, {
						id: toast.id,
					})
				} else if (toast.type === 'error') {
					showToast.error(message, {
						id: toast.id,
					})
				} else {
					showToast(message, {
						id: toast.id,
					})
				}
			}, 0)
		}
	}, [toast])
}
